<template>
    <div class="book-preview">
        <router-link :to="url">
            <div class="book-preview__media">
                <div class="book-preview__rating" v-if="rating">
                    <icon-star />

                    <span>
                        {{rating}}
                    </span>
                </div>

                <div class="book-preview__image" :style="{'background-image': `url(${coverSrc})`}"></div>
            </div>

            <div class="book-preview__content">
                <h4>{{title}}</h4>
            </div>
        </router-link>
    </div>
</template>

<script>
import IconStar from '@/components/icons/icon-star/icon-star';

export default {
    name: 'BookPreview',

    components: {
        IconStar
    },

    props: {
        url: {
            type: [String],
            default: '/'
        },

        coverSrc: {
            type: String,
            default: ''
        },

        title: {
            type: String,
            default: ''
        },

        rating: {
            type: [Number, String],
            default: ''
        }
    },
}
</script>
